import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import DashboardBarChart from "./dashboardBarChart";
import DashboardPieChart from "./dashboardPieChart";
import DashboardAbsentChart from "./dashboardAbsentChart";
import TimesheetDashboard from "./dashboardTimsheet";

const DashboardCharts = () => {
  const isDesktop = useResponsive("up", "lg", "xl");
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const theme = useTheme();

  return (
    <>
      <Grid container sx={{ my: 3 }} gap={isSmall ? 4 : 3}>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 7 : 8}
          sx={{ padding: isSmall ? 0 : 2 }}
        >
          <Box
            sx={{
              paddingX: isSmall ? 0 : 2,
              paddingY: 2,
              marginY: 2,
              backgroundColor: theme.palette.common.white,
              borderRadius: "10px",

              width: "100%",
              height: "100%",
            }}
          >
            <DashboardBarChart />
          </Box>
        </Grid>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 4.4 : 3.6}
          sx={{ padding: isSmall ? 0 : 2 }}
        >
          <Box
            sx={{
              paddingX: isSmall ? 0 : 2,
              paddingY: 2,
              marginY: 2,
              backgroundColor: theme.palette.common.white,
              borderRadius: "10px",

              width: "100%",
              height: "100%",
            }}
          >
            <DashboardPieChart />
          </Box>
        </Grid>
      </Grid>

      <Grid container sx={{ my: 3 }} gap={isSmall ? 4 : 3}>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 6 : 6}
          sx={{ padding: isSmall ? 0 : 2 }}
        >
          <Box
            sx={{
              paddingX: isSmall ? 0 : 2,
              paddingY: 2,
              marginY: 2,
              backgroundColor: theme.palette.common.white,
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              width: "100%",
              height: "100%",
            }}
          >
            <Typography
              variant="subtitle2"
              color={"neutral"}
              sx={{
                fontWeight: 700,
                fontFamily: "Inter",
                letterSpacing: "3%",
                mb: 1,
                mt: 2,
                paddingX: 2,
              }}
            >
              Timesheet analysis
            </Typography>

            <TimesheetDashboard />
          </Box>
        </Grid>
        <Grid
          item
          xs={isSmall ? 12 : isMedium ? 5.6 : 5.8}
          sx={{ padding: isSmall ? 0 : 2 }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.common.white,
              borderRadius: "10px",
              marginY: 2,
              width: "100%",
              height: "100%",
            }}
          >
            <DashboardAbsentChart />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DashboardCharts;
